import { OfferVisualIcon, type OfferVisualIconName } from './OfferVisualIcon';

export function OfferErrorState({ title, text, icon = 'warning' }: { title: string; text: string; icon?: OfferVisualIconName }) {
  return <div className="offer-campaign-panel-message"><OfferVisualIcon name={icon} /><strong>{title}</strong><span>{text}</span></div>;
}

export function CampaignBlocked({ title, text, icon = 'warning', onRefresh }: { title: string; text: string; icon?: OfferVisualIconName; onRefresh: () => void }) {
  return (
    <div className="offer-campaign-work-panel">
      <OfferErrorState title={title} text={text} icon={icon} />
      <button
        className="btn btn-outline admin-pdf-export-btn offer-campaign-refresh-campaign-button"
        type="button"
        onClick={onRefresh}
        style={{ display: 'inline-flex', alignItems: 'center', gap: 8, height: 48, borderRadius: 12, fontWeight: 700, border: '1px solid var(--primary)', color: 'var(--primary)', background: 'transparent' }}
      >
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
          <path d="M3 3v5h5" />
          <path d="M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16" />
          <path d="M16 16h5v5" />
        </svg>
        Refresh campaign details
      </button>
    </div>
  );
}
